var _rect, _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#286385",
    stroke: "#286385"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 25C24.7625 25 27 22.7625 27 20C27 17.2375 24.7625 15 22 15C19.2375 15 17 17.2375 17 20C17 22.7625 19.2375 25 22 25ZM22 27.5C18.6625 27.5 12 29.175 12 32.5V33.75C12 34.4375 12.5625 35 13.25 35H30.75C31.4375 35 32 34.4375 32 33.75V32.5C32 29.175 25.3375 27.5 22 27.5Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 25.4495L32.3224 24.6737L30.3187 22.6699L29.5625 25.4495Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0585 14.8249C38.8826 14.6494 38.6442 14.5508 38.3956 14.5508C38.1471 14.5508 37.9087 14.6494 37.7327 14.8249L37.2988 15.2588L39.716 17.7023L40.1631 17.2554C40.3386 17.0795 40.4372 16.8411 40.4372 16.5925C40.4372 16.344 40.3386 16.1056 40.1631 15.9296L39.0585 14.8249Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5449 22.0129L32.9753 24.4432L39.2743 18.1442L36.8571 15.7007L30.5449 22.0129Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(7 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthor);
export default __webpack_public_path__ + "static/media/author.09af842cb7a83b7feb5111e5315aad13.svg";
export { ForwardRef as ReactComponent };